import { __assign, __read } from "tslib";
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { fallBackManifest, getDefaultResources, manifest, } from '@office-start/locstrings-service';
import { requestWithInstrumentation } from '@office-start/xhr-service';
/**
 * @param partnerResourceIdentifier (optional for TAOS, required for partners)
 * Name of the JSON containing default english strings under locstrings-service-package/src/strings/
 * ex: "search-me-control-resources" for search-me-control-resources.json.
 * Note: Incase .json has been added, it will be stripped off before usage under getLocStrings.ts
 */
export function getLocStrings(cdnDomain, preferredCulture, stringsContainerName, partnerResourceIdentifier, featureGates) {
    if (partnerResourceIdentifier === void 0) { partnerResourceIdentifier = 'office-start-resources'; }
    var preferredCultureLowercase = preferredCulture === null || preferredCulture === void 0 ? void 0 : preferredCulture.toLowerCase();
    var resourceExists = preferredCultureLowercase && manifest;
    var defaultResources = getDefaultResources(partnerResourceIdentifier).then(function (resources) {
        var _a, _b;
        if ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.m365StringLogoGates) === null || _b === void 0 ? void 0 : _b.m365StringLogoEnabled) {
            return updateM365Strings(resources);
        }
        return resources;
    });
    if (!resourceExists) {
        return Promise.resolve(defaultResources);
    }
    preferredCultureLowercase = getMostCompatibleLocale(preferredCultureLowercase, partnerResourceIdentifier);
    if (preferredCultureLowercase === 'en' ||
        preferredCultureLowercase === 'default') {
        return Promise.resolve(defaultResources);
    }
    var resourceUrl = "https://".concat(cdnDomain, "/").concat(stringsContainerName, "/").concat(manifest[updateManifestKey(partnerResourceIdentifier, preferredCultureLowercase)]);
    var requestConfig = {
        method: "GET" /* HttpRequestMethod.Get */,
        responseType: "json" /* HttpResponseContentType.Json */,
        url: resourceUrl,
    };
    return requestWithInstrumentation(KnownInstrumentationEvents.ResourceStringsFetch, "Resource_Strings_Fetch" /* KnownRequestInstrumentationEvents.ResourceStringsFetch */, requestConfig)
        .then(function (_a) {
        var _b, _c;
        var data = _a.data;
        var resourceStringsJson = data;
        if ((_c = (_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _b === void 0 ? void 0 : _b.m365StringLogoGates) === null || _c === void 0 ? void 0 : _c.m365StringLogoEnabled) {
            return Promise.resolve(updateM365Strings(resourceStringsJson));
        }
        return resourceStringsJson;
    })
        .catch(function () {
        return Promise.resolve(defaultResources);
    });
}
export function applyOverrideLocale(culture) {
    if (fallBackManifest && fallBackManifest[culture]) {
        culture = fallBackManifest[culture];
    }
    return culture;
}
function updateM365Strings(resourceStringsJson) {
    var newResourceStringsJson = {};
    var _loop_1 = function (resourceGroupName) {
        if (resourceStringsJson.hasOwnProperty(resourceGroupName)) {
            var resourceGroup_1 = resourceStringsJson[resourceGroupName];
            var newResourceGroup_1 = __assign({}, resourceGroup_1);
            Object.keys(resourceGroup_1)
                .filter(function (key) { return key.startsWith('m365_'); })
                .forEach(function (key) {
                newResourceGroup_1[key.slice(5)] = resourceGroup_1[key];
            });
            newResourceStringsJson[resourceGroupName] = newResourceGroup_1;
        }
    };
    for (var resourceGroupName in resourceStringsJson) {
        _loop_1(resourceGroupName);
    }
    return newResourceStringsJson;
}
function getMostCompatibleLocale(locale, partnerResourceIdentifier) {
    //apply locale override if applicable.
    locale = applyOverrideLocale(locale);
    if (manifest[updateManifestKey(partnerResourceIdentifier, locale)]) {
        return locale;
    }
    //finding most compatible locale based on prefixes(lang vs culture). returning default,en, if no match found.
    //for ex: if hi-in doesn't exist, check whether the prefix (hi) exists.
    var _a = __read(locale.split('-'), 1), preferredLang = _a[0];
    if (manifest[updateManifestKey(partnerResourceIdentifier, preferredLang)]) {
        return preferredLang;
    }
    return 'default';
}
function updateManifestKey(partnerResourceIdentifier, preferredCulture) {
    return "".concat(preferredCulture, "/").concat(partnerResourceIdentifier);
}
//# sourceMappingURL=getLocStrings.js.map